// eslint-disable-next-line no-console
let connectionErrorCallback = (errorMessage) => console.error(errorMessage);
function notifyConnectionError(errorMessage) {
    if (connectionErrorCallback) {
        connectionErrorCallback(errorMessage);
    }
}
function setConnectionErrorCallback(callback) {
    connectionErrorCallback = callback;
}

export { notifyConnectionError, setConnectionErrorCallback };
